import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import Input from "../../../Components/Input";
import Select from "../../../Components/Select";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../../../Components/DateInput";
import { MultiSelect } from "react-multi-select-component";
import ErrorContainer from "../../../Components/ErrorContainer";
import BuyAssets from "./BuyAssets";
import { getFormData } from "../../../../helpers";
import OutstandingInvoices from "./OutstandingInvoices";
import AvailaibleCreditNotes from "./AvailaibleCreditNotes";
import OtherDebt from "./OtherDebt";
import LinkedInvoices from "./LinikedInvoices";

const EditPayment = (params) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const id = params?.location?.state?.id;
  const editFormOptions = useSelector(
    (state) => state.financeReducer?.editPaymentData
  );

  let defaultValues = {
    payee_id: "",
    amount: "",
    tax: "",
    tax_included_in_amount: "",
    transaction_ID: "",
    purpose_id: "",
    expense_account_id: "",
    liability_account_id: "",
    asset_account_id: "",
    account_id: "",
    payment_account_id: "",
    invoice_date: moment(new Date()).format("YYYY-MM-DD"),
    transaction_date: moment().format("YYYY-MM-DD"),
    memo: "",
    attachment: "",
  };

  const [localFormState, setLocalFormState] = useState(defaultValues);
  const [selectedPayee, setSelectedPayee] = useState([]);
  const [selectedExpense, setSelectedExpense] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState(new Date());
  const [transactionDate, setTransactionDate] = useState(new Date());

  // outstanding invoices table state
  const [outstandingInvoicesState, setOutstandingInvoicesState] = useState({
    from_date: null,
    to_date: null,
    account_id: [],
    isAllSelected: false,
    selectedItemId: [],
    totalAmount: 0,
  });

  // LinkedInvoices table state
  const [linkedInvoicesState, setLinkedInvoicesState] = useState({
    isAllSelected: false,
    selectedItemId: [],
    totalAmount: 0,
  });

  // asset form state
  const assetFormState = useSelector(
    (state) => state?.financeReducer?.assetFormState
  );
  const setAssetFormState = (state) =>
    dispatch(
      actions?.setFormState({ formName: "assetFormState", formState: state })
    );

  useEffect(() => {
    dispatch(
      actions?.getEditPaymentData({
        id: id,
      })
    );
  }, []);

  // initialising view payment data
  useEffect(() => {
    if (editFormOptions) {
      const paymentEditData = editFormOptions?.payments;
      defaultValues = {
        payee_id: paymentEditData?.payee_id,
        amount: paymentEditData?.amount,
        tax: paymentEditData?.payee_id,
        tax_included_in_amount: paymentEditData?.tax_included_in_amount,
        transaction_ID: paymentEditData?.transaction_ID,
        purpose_id: paymentEditData?.purpose_id,
        expense_account_id: paymentEditData?.expense_account_id,
        liability_account_id: paymentEditData?.liability_account_id,
        asset_account_id: paymentEditData?.asset_account_id,
        account_id: paymentEditData?.account_id,
        payment_account_id: paymentEditData?.payment_account_id,
        invoice_date: paymentEditData?.invoice_date,
        transaction_date: paymentEditData?.transaction_date,
        memo: paymentEditData?.memo,
        attachment: paymentEditData?.attachment,
      };
      reset(defaultValues);
      setLocalFormState(defaultValues);
      setSelectedPayee([
        editFormOptions?.suppliers?.find(
          (el) => el.value == paymentEditData?.payee_id
        ),
      ]);
      setSelectedExpense([
        editFormOptions?.expense_account?.find(
          (el) => el.value == paymentEditData?.expense_account_id
        ),
      ]);
    }
  }, [editFormOptions]);

  const schema = yup.object().shape({
    payee_id: yup.string().required().required(),
    amount: yup.string().required().required(),
    tax: yup.string().required(),
    tax_included_in_amount: yup.string().required(),
    transaction_ID: yup.string().required(),
    purpose_id: yup.string().required(),
    expense_account_id:
      localFormState?.purpose_id == 1 ? yup.string().required() : yup.string(),
    liability_account_id:
      localFormState?.purpose_id == 4 ? yup.string().required() : yup.string(),
    asset_account_id:
      localFormState?.purpose_id == 5 ? yup.string().required() : yup.string(),
    account_id: yup.string(),
    payment_account_id: yup.string(),
    invoice_date: yup.string(),
    transaction_date: yup.string(),
    memo: yup.string(),
    attachment: yup.mixed(),
  });
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: defaultValues,
  });

  function submitData(data) {
    dispatch(
      actions?.postAddPaymentsFormData(
        getFormData({ ...data, attachment: data.attachment[0] })
      )
    );
  }
  function handlePurpose(e) {
    const value = e.target.value;
    setLocalFormState({ ...localFormState, purpose_id: value });
    console.log("aaaaaa", value);

    switch (+value) {
      case 2:
        dispatch(
          actions?.getPayTradeLiabilityData({
            payee_id: localFormState.payee_id,
          })
        );
        break;

      case 3:
        dispatch(
          actions?.getInvoicesData({ payee_id: localFormState.payee_id })
        );
        break;
      case 6:
        dispatch(
          actions?.getApLiabilityData({ payee_id: localFormState.payee_id })
        );
        break;

      default:
        break;
    }
  }
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            {console.log(errors)}
            <div className="row d-flex">
              <div className="col-xl-5 col-lg-8 modify">
                <form onSubmit={handleSubmit(submitData)}>
                  <div className="shadowclass mt-4 d-flex flex-wrap align-content-start p-4">
                    <h4 className="event-alert w-100 mb-0">Edit Payment </h4>
                    <div className="row col-12 mx-0">
                      <div className="settings-right-content scrolling px-0 pt-3">
                        <div className="date-sec-scroll">
                          <div
                            id="MenuItemInfo"
                            className="row-fluid scroll-change full_div"
                            day_time="Address"
                          >
                            <div className="form-secs">
                              <ul class="ingredient-info edit-shift">
                                <li class="deactivate-input">
                                  <label class="required">Payee Name </label>
                                  <div class="input-group select-div col-md-7 multiselect ">
                                    <MultiSelect
                                      value={selectedPayee}
                                      closeOnChangedValue={true}
                                      {...register("payee_id")}
                                      onChange={(arr) => {
                                        const selectedOption =
                                          arr[arr.length - 1];

                                        if (selectedOption) {
                                          setSelectedPayee([selectedOption]);
                                          setLocalFormState({
                                            ...localFormState,
                                            payee_id: selectedOption?.value,
                                          });
                                          setValue(
                                            "payee_id",
                                            selectedOption?.value
                                          );
                                          dispatch(
                                            actions.getExpenseTypeData({
                                              id: selectedOption?.value,
                                            })
                                          );
                                        } else {
                                          setSelectedPayee([]);
                                        }
                                      }}
                                      labelledBy="Promo Code"
                                      showCheckbox={true}
                                      hasSelectAll={false}
                                      options={editFormOptions?.suppliers ?? []}
                                    />
                                  </div>
                                  <ErrorContainer
                                    errors={errors}
                                    name={"payee_id"}
                                  />
                                </li>
                                <Input
                                  label={"Amount"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"amount"}
                                />

                                <Input
                                  label={"Tax"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"tax"}
                                />

                                <Select
                                  label={"Tax included in amount"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"tax_included_in_amount"}
                                  optionsArray={editFormOptions?.yes_no}
                                />
                                <Input
                                  label={"Invoice ID"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"transaction_ID"}
                                />

                                <Select
                                  onChange={(e) => handlePurpose(e)}
                                  label={"Purpose"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"purpose_id"}
                                  optionsArray={editFormOptions?.purposes}
                                  deactivate={true}
                                />
                                <Select
                                  onChange={(e) =>
                                    setLocalFormState({
                                      ...localFormState,
                                      account_id: e.target.value,
                                    })
                                  }
                                  label={"Account"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"account_id"}
                                  optionsArray={editFormOptions?.subaccounts}
                                />
                                {localFormState?.purpose_id == 1 && (
                                  <li>
                                    <label class="required">Expense</label>
                                    <div class="input-group select-div col-md-7 multiselect">
                                      <MultiSelect
                                        value={selectedExpense}
                                        closeOnChangedValue={true}
                                        {...register("expense_account_id")}
                                        onChange={(arr) => {
                                          const selectedOption =
                                            arr[arr.length - 1];

                                          console.log(selectedOption, "lllll");
                                          if (selectedOption) {
                                            setSelectedExpense([
                                              selectedOption,
                                            ]);
                                            setLocalFormState({
                                              ...localFormState,
                                              expense_account_id:
                                                selectedOption?.value,
                                            });
                                            setValue(
                                              "expense_account_id",
                                              selectedOption?.value
                                            );
                                          } else {
                                            setSelectedExpense([]);
                                          }
                                        }}
                                        labelledBy="Promo Code"
                                        showCheckbox={true}
                                        hasSelectAll={false}
                                        options={
                                          editFormOptions?.expense_account ?? []
                                        }
                                      />
                                      <ErrorContainer
                                        errors={errors}
                                        name={"expense_account_id"}
                                      />
                                    </div>
                                  </li>
                                )}
                                {localFormState?.purpose_id == 4 && (
                                  <Select
                                    label={"Liability Account"}
                                    formRegister={register}
                                    formError={errors}
                                    formKey={"liability_account_id"}
                                    optionsArray={
                                      editFormOptions?.liability_accounts
                                    }
                                    onChange={(e) => {
                                      setLocalFormState({
                                        ...localFormState,
                                        liability_accounts: e.target.value,
                                      });
                                      dispatch(
                                        actions?.getPayOtherDebtData({
                                          payee_id: localFormState?.payee_id,
                                          liability_account_id: e.target.value,
                                        })
                                      );
                                    }}
                                  />
                                )}
                                {localFormState?.purpose_id == 5 && (
                                  <Select
                                    label={"Asset Account"}
                                    formRegister={register}
                                    formError={errors}
                                    formKey={"asset_account_id"}
                                    optionsArray={
                                      editFormOptions?.asset_accounts
                                    }
                                    onChange={(e) => {
                                      setAssetFormState(false);
                                      setLocalFormState({
                                        ...localFormState,
                                        asset_account_id: e.target.value,
                                      });
                                      dispatch(
                                        actions?.getBuyAssetData({
                                          payee_id: localFormState?.payee_id,
                                          asset_account_id: e.target.value,
                                        })
                                      );
                                    }}
                                  />
                                )}
                                <Select
                                  label={"Payment Account"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"payment_account_id"}
                                  optionsArray={
                                    editFormOptions?.paymentAccounts
                                  }
                                  onChange={(e) => {
                                    setLocalFormState({
                                      ...localFormState,
                                      payment_account_id: e.target.value,
                                    });
                                  }}
                                />

                                <DateInput
                                  label={"Invoice Date"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey="invoice_date"
                                  setFormField={setValue}
                                  dateVal={invoiceDate}
                                  horizontal={true}
                                  setDateVal={setInvoiceDate}
                                />
                                <DateInput
                                  label={"Transaction Date"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey="transaction_date"
                                  setFormField={setValue}
                                  dateVal={transactionDate}
                                  horizontal={true}
                                  setDateVal={setTransactionDate}
                                />

                                <Input
                                  label={"Memo"}
                                  formRegister={register}
                                  formError={errors}
                                  formKey={"memo"}
                                />
                                <li class="add-border pt-3">
                                  <label class="">Attachment</label>
                                  <div class="input-group col-md-7 first add-filebtn">
                                    Browse
                                    <div class="input file">
                                      <input
                                        {...register("attachment")}
                                        type="file"
                                      />
                                    </div>
                                  </div>
                                  <span class="showBrowseFile"></span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mx-0 w-100 py-0">
                      <div class="container px-0 d-flex col-12">
                        <div class="btns col-4 d-flex justify-content-end col-12">
                          <button
                            onClick={() => history.goBack()}
                            id="cancel"
                            type="button"
                          >
                            Cancel
                          </button>
                          <button type="submit">Submit</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-xl-7 col-lg-8 modify">
                {localFormState.purpose_id == 3 && (
                  <LinkedInvoices
                    linkedInvoicesState={linkedInvoicesState}
                    setLinkedInvoicesState={setLinkedInvoicesState}
                    editFormOptions={editFormOptions}
                    pageType={"editPayment"}
                  />
                )}
                {localFormState.purpose_id == 4 && <OtherDebt />}
                {localFormState.purpose_id == 5 && (
                  <BuyAssets
                    localFormState={localFormState}
                    setAssetFormState={setAssetFormState}
                    assetFormState={assetFormState}
                    editFormOptions={editFormOptions}
                    pageType={"editPayment"}
                  />
                )}
                {(localFormState.purpose_id == 6 ||
                  localFormState.purpose_id == 2) && (
                  <OutstandingInvoices
                    outstandingInvoicesState={outstandingInvoicesState}
                    setOutstandingInvoicesState={setOutstandingInvoicesState}
                    localFormState={localFormState}
                    editFormOptions={editFormOptions}
                    pageType={"editPayment"}
                  />
                )}
                {localFormState.purpose_id == 6 && (
                  <AvailaibleCreditNotes
                    editFormOptions={editFormOptions}
                    localFormState={localFormState}
                    pageType={"editPayment"}
                  />
                )}
              </div>
            </div>{" "}
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default EditPayment;
